import { observer } from 'mobx-react-lite'
import { getSnapshot } from 'mobx-state-tree'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import { Form } from '../../../../models'
import { PROJECT_SECTIONS } from '../../../../models/src/dictionaries'
import { Spacer } from '../../ui/atoms'
import {
  BackButton,
  ConditionalTitle,
  NextButton,
  ProgressHeader,
  SectionTitle,
  SectionSubtitle,
} from './components'
import { Question } from './Question'
import ProjectStore from './Store'

interface QuestionnaireLayoutProps {
  route: any
  navigation: any
}

export const QuestionnaireLayout: React.FC<QuestionnaireLayoutProps> = observer(
  ({ route, navigation }) => {
    const { t } = useTranslation('global')
    const {
      currentSection,
      questionsUnderCurrentSection,
      formData,
      setUpSection,
      setFormData,
    } = ProjectStore

    console.log('===== FORM DATA =====', formData && getSnapshot(formData))

    useEffect(() => {
      if (!route.params?.projectId) {
        setFormData(Form.create({ currentSection: PROJECT_SECTIONS.ADDRESS }))
      }
      setUpSection(PROJECT_SECTIONS.ADDRESS)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <View style={{ flex: 1 }}>
        <ProgressHeader />
        <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
          <View style={{ alignSelf: 'center', width: 600 }}>
            <ConditionalTitle
              section={formData?.currentSection}
              route={route}
            />
            <SectionTitle>{t(currentSection?.title)}</SectionTitle>
            {currentSection?.subtitle && (
              <SectionSubtitle>{t(currentSection?.subtitle)}</SectionSubtitle>
            )}
            {questionsUnderCurrentSection?.map((ini) => {
              return (
                <Question
                  section={formData?.currentSection}
                  question={ini}
                  key={ini.identifier}
                />
              )
            })}
            <View style={{ alignItems: 'flex-end' }}>
              <View style={{ flexDirection: 'row', marginVertical: 30 }}>
                <BackButton navigation={navigation} />
                <Spacer width={20} />
                <NextButton />
              </View>
            </View>
          </View>
        </ScrollView>
      </View>
    )
  },
)
